import ProfileInfo from './components/ProfileInfo';
import ProfileStyles from './styles';

const Profile = () => (
  <ProfileStyles>
    <ProfileInfo />
  </ProfileStyles>
);

Profile.propTypes = {};

export default Profile;
